import { render, staticRenderFns } from "./unlock-request.vue?vue&type=template&id=af180b2c&functional=true"
import script from "./unlock-request.vue?vue&type=script&lang=js"
export * from "./unlock-request.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports